import { useMutation } from "react-query";
import { endFreeTrial } from "../../../../../api-services/account-information";

export const useEndFreeTrialMutation = () => useMutation(endFreeTrial);
